export const AppealSupplementaryResponseDisplay = ({ appealSupplementaryResponse }) => {

    return (
        <div className="card-body bg-light border-top details-container">
            <div className="row">
                <div className="col-md-3 col-12">
                    <p className="font-weight-semi-bold mb-3 mt-1">Name</p>
                </div>
                <div className="col-md-6 col-12"><p className="mb-0">{ appealSupplementaryResponse.name }</p></div>
            </div>
            <div className="row">
                <div className="col-md-3 col-12">
                    <p className="font-weight-semi-bold mb-3">Content</p>
                </div>
                <div className="col-md-6 col-12"><p className="mb-0" style={ { whiteSpace: "pre-wrap" } }>{ appealSupplementaryResponse.content }</p></div>
            </div>
        </div>
    )
}
